export function maskSsn(value) {
  if (!value) {
    return '';
  }

  const data = value.toString();

  return `${data.substr(0, 3)}-${data.substr(3, 2)}-${data.substr(5)}`;
}
